import { atom } from 'jotai';
export const atomSummaryOpen = atom(false);
export const atomSummaryMessage = atom('');
